import React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#1890ff",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function CompanyEarning() {
  const data = [
    {
      id: 1,
      company_name: "Syoft",
      active_openings: 10,
      number_of_hires: 5,
      candidates_screened: 300,
      commission_earned: 30000,
    },
    {
      id: 1,
      company_name: "Syoft",
      active_openings: 10,
      number_of_hires: 5,
      candidates_screened: 300,
      commission_earned: 30000,
    },
    {
      id: 1,
      company_name: "Syoft",
      active_openings: 10,
      number_of_hires: 5,
      candidates_screened: 300,
      commission_earned: 30000,
    },
    {
      id: 1,
      company_name: "Syoft",
      active_openings: 10,
      number_of_hires: 5,
      candidates_screened: 300,
      commission_earned: 30000,
    },
  ];
  return (
    <div className="p-3">
      <h5 className="mb-3">Companies</h5>
      <div className="card border-0 table-bg">
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 700 }} aria-label="customized table">
            <caption className="p-5">
              <Stack>
                <Pagination
                  count={10}
                  shape="rounded"
                  style={{ margin: "auto" }}
                />
              </Stack>
            </caption>
            <TableHead>
              <TableRow>
                <StyledTableCell>S.No</StyledTableCell>
                <StyledTableCell align="center">Company</StyledTableCell>
                <StyledTableCell align="center">
                  Active Openings
                </StyledTableCell>
                <StyledTableCell align="center">
                  Number of Hires
                </StyledTableCell>
                <StyledTableCell align="center">
                  Candidates Screened
                </StyledTableCell>
                <StyledTableCell align="center">
                  Commissions Earned
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map(row => (
                <StyledTableRow key={row.id}>
                  <StyledTableCell component="th" scope="row">
                    {row.id}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {row.company_name}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {row.active_openings}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {row.number_of_hires}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {row.candidates_screened}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    Rs. {row.commission_earned}
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
}

export default CompanyEarning;
